export const isProd = import.meta.env.VITE_APP_TRAIN_ENV === 'production';
